/** "0850 888 27 40" → "tel:+908508882740"; "+90 …" korunur; tanınmayan biçimde rakamlar olduğu gibi */
export function telHref(phone: string): string {
  const digits = phone.replace(/[^\d+]/g, "");
  if (digits.startsWith("+")) return `tel:${digits}`;
  if (digits.startsWith("0") && digits.length === 11) return `tel:+90${digits.slice(1)}`;
  return `tel:${digits}`;
}

export type SocialLink = { label: string; href: string };

export function socialLinks(c: { instagram: string; facebook: string; linkedin: string }): SocialLink[] {
  return [
    { label: "Instagram", href: c.instagram },
    { label: "Facebook", href: c.facebook },
    { label: "LinkedIn", href: c.linkedin },
  ].filter((s) => s.href);
}

/**
 * WhatsApp sohbet bağlantısı: "0532 000 00 00" / "+90 532 …" / "532 …" → https://wa.me/90532…?text=…
 * Numara tanınmazsa null (düğme gösterilmez).
 */
export function whatsappHref(phone: string, text?: string): string | null {
  let digits = phone.replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  else if (digits.startsWith("0") && digits.length === 11) digits = `90${digits.slice(1)}`;
  else if (digits.length === 10 && digits.startsWith("5")) digits = `90${digits}`;
  if (digits.length < 11 || digits.length > 15) return null;
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}
